export default __webpack_public_path__ + "static/illustration-content-button.url-4d35fb08079643e4c06feebab2b18f37.svg";